<script>
import { required } from "vuelidate/lib/validators";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
//import moment from "moment";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import store from "@/state/store";
import Eylem from "./Eylem"
import EylemKontrolKanit from "./EylemKontrolKanit"
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import Swal from "sweetalert2";

export default {
  mixins: [Api, Sabit],
  page: {
    title: "Risk Eylem Planı",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    formcombobox,
    BirimSecimi,
    Eylem,
    formtextarea,
    EylemKontrolKanit
  },
  data() {
    return {
      title: this.$t("StrRiskEylemPlani.Title"),
      items: [
        {
          text: this.$t("StrRiskEylemPlani.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrRiskEylemPlani.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrRiskEylemPlani.Title"),
          active: true,
        },
      ],
      KullaniciBilgileri: null,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FormDataType: {
        Aciklama: {
          FieldName: "Aciklama",
          Field: "input",
          FieldTitle: this.$t("StrPerfDonem.AddEdit.Aciklama"),
          Disabled: false
        },
      },
      FormData: {},
      RiskPuanlar: {},
      KontrolGet: false,
      Kontrolgirisid: "",
      DefaultPage: 1,
      TableData: [],
      AllKontrolData: [],
      count: 0,
      TableDataGroup: {},
      secilen_birim: null,
      ComboBoxBirimId: [],
      ComboBoxDonemId: [],
      ComboBoxAltDonemId: [],
      SecilenGerceklesme: {},
      RiskTipiComboBox: [
          {Id:"1",Value:"Kurumsal Riskler"},
          {Id:"2",Value:"Operasyonel Riskler"}
        ],
      Raporgirisid: "",
      Filter: {
        BirimId: null,
        DonemId: "",
        AltDonemId: "",
        Risktipi: "",
      },
      SorguKontrol: false,
      OnayDurumu: false,
      AltDonemAktif: false
    };
  },
  watch:{

  },
  validations: {
    Filter: {
      BirimId: { required },
      DonemId: { required },
      AltDonemId: { required },
      Risktipi: { required },
    },
    FormData: {
      Aciklama: {},
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid.FormData) {
        this.Update("StrRisklerGirislerCevap", this.FormData).then((res) => {
          if (res) {
            this.$bvModal.hide("EylemKontrolAciklama");
            this.AllKontrolGet();
          }
        });
      }
    },
    Get() {
      this.KullaniciBilgileri = store.getters.["auth/UserRolles"]
    },
    FilterGet(){
      this.$v.$touch();
      if (!this.$v.$invalid) { 
          let Filter ="&Asc=Risk"
          if(this.Filter.Risktipi!=null && this.Filter.Risktipi!="")
          Filter=Filter+"&Risktipi=" +this.Filter.Risktipi;
          if(this.Filter.DonemId!=null && this.Filter.DonemId!="")
          Filter=Filter+"&DonemId=" +this.Filter.DonemId;
          if(this.Filter.BirimId!=null && this.Filter.BirimId!="")
          Filter=Filter+"&BirimId=" +this.Filter.BirimId;
          this.ActionsFilterGet({Service:"StrRisk", Page:this.Page, Filter:Filter}).then((res) => {
              if(res){
              this.TableData = [];
              for (var i = 0; i < res.Data.length; i++) {
                if((this.$options.filters.formatDate(this.SecilenGerceklesme.BaslamaTarihi) <= this.$options.filters.formatDate(res.Data[i].Created) && this.$options.filters.formatDate(res.Data[i].Created)  <= this.$options.filters.formatDate(this.SecilenGerceklesme.BitisTarihi)) || (this.$options.filters.formatDate(this.SecilenGerceklesme.BaslamaTarihi) >= this.$options.filters.formatDate(res.Data[i].Created))){   
                        console.log(res.Data[i])
                        this.TableData.push(res.Data[i]);
             
                }
              }
          

              }   
            
          });

          this.AllKontrolGet();
      }


    },
    DonemBaslamaTarihi(Donemid){
      this.SecilenGerceklesme = this.ComboBoxAltDonemId.filter((notification) =>
        notification.Id.includes(Donemid)
      )[0];
      const originalDate = new Date();
      if((this.SecilenGerceklesme.BaslamaTarihi <= this.$options.filters.formatDate(originalDate)) && (this.$options.filters.formatDate(originalDate)  <= this.SecilenGerceklesme.BitisTarihi)){
          this.AltDonemAktif = true
      }else{
        this.AltDonemAktif = false
      }
    },
    BirimEylemOnay1(){
      this.AllKontrolGet();
      this.count = 0;
      for(var Data in this.AllKontrolData){
        this.OnayFormData = null
        for(var Data2 in this.AllKontrolData[Data]){
        this.OnayFormData = this.AllKontrolData[Data][Data2]
        if(this.OnayFormData.Aciklama == null || this.OnayFormData.Aciklama == '' || this.OnayFormData.Tamamlanma != 2){
          if(this.OnayFormData.Aciklama == null || this.OnayFormData.Aciklama == ''){
            this.$toast.error(this.OnayFormData.Cevap + ' Eylemi açıklaması eksik!');
            this.count += 1
          }
          if(this.OnayFormData.Tamamlanma == null || this.OnayFormData.Tamamlanma == ''){
            this.$toast.error(this.OnayFormData.Cevap + ' Eylemi durumu eksik!');
            this.count += 1
          }
        }
      }
    }
    if(this.count==0){
      this.BirimEylemOnay();
    }
    },
    BirimEylemOnayKaldir(){
    return Swal.fire({
      title: 'Eylem Durumları Onayı Kaldırılsın Mı?',
      text: 'Eylem Durumları Onayı Kaldırılsın Mı?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
    }).then((result) => {
      if (result.value) {
    for(var Data in this.AllKontrolData){
      this.OnayFormData = null
      for(var Data2 in this.AllKontrolData[Data]){
      this.OnayFormData = this.AllKontrolData[Data][Data2]
      this.OnayFormData.Onay = 0;
      this.Update("StrRisklerGirislerCevap", this.OnayFormData, false);
    }

    }
    this.$toast.success('Eylemler Onayları Kaldırıldı');
    this.KontrolGet = true;
    this.FilterGet();


    }
    });

    },
    AllKontrolGet(){
      this.KontrolGet = false;
      let Filter = "&DonemId=" + this.Filter.AltDonemId +"&BirimId=" + this.Filter.BirimId;
        this.ActionsFilterGet({ Service: "StrRiskGiris", Page: this.Page, Filter: Filter }).then((res) => {
          this.AllKontrolData = [];
          for(var Data in res.Data){
            this.ActionsFilterGet({Service:"StrRisklerGirislerCevap", Page:this.Page,Filter: "&BirimId=" +this.Filter.BirimId + "&GirisId=" + res.Data[Data].Id + "&CevapTipi=" + res.Data[Data].Kontrolturu}).then((res) => {
              if(res.Data.Durum != 1){
                this.AllKontrolData.push(res.Data);
              }

                  }); 
          }
        });
                
            
    },
    BirimEylemOnay(){
     
     return Swal.fire({
       title: 'Eylem Durumları Onaylansın Mı?',
       text: 'Eylem Durumları Onaylansın Mı?',
       icon: "warning",
       showCancelButton: true,
       confirmButtonColor: "#34c38f",
       cancelButtonColor: "#f46a6a",
       confirmButtonText: "Evet",
       cancelButtonText: "Hayır",
     }).then((result) => {
       if (result.value) {
     for(var Data in this.AllKontrolData){
       this.OnayFormData = null
       for(var Data2 in this.AllKontrolData[Data]){
       this.OnayFormData = this.AllKontrolData[Data][Data2]
       this.OnayFormData.Onay = 1;
       this.Update("StrRisklerGirislerCevap", this.OnayFormData, false);
     }

     }
     this.$toast.success('Eylemler Onaylandı');
     this.FilterGet();
     this.KontrolGet = true;
   }
     });
   },

    Secilmis_Idler(secilmis) {
      if (secilmis != null) {
       
          this.secilen_birim = secilmis;
          this.Filter.BirimId = this.secilen_birim;
          if(this.secilen_birim==this.universite_id){
            this.universite=1;
          } else{ this.universite=0;}
      }
    },
    DonemSec() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.ComboBoxAltDonemId = [];
      if (this.Filter.DonemId) {
   //     let Tarih = moment(new Date()).format("YYYY-MM-DD");
        this.ActionsFilterGet({ Service: "okeyvalues", Page: this.Page, Filter: "&Tip=1561&Kod=5" }).then((resp) => {
          let Filter = "&UstId=" + this.Filter.DonemId + "&TipId=" + resp.Data[0].Id + "&Approval=true";
          this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: Filter }).then((res) => {
            for (var i = 0; i < res.Data.length; i++) {
         //     if (this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= Tarih && Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)) {
                if (res.Data[i].Approval) {
                  this.ComboBoxAltDonemId.push({
                    Id: res.Data[i].Id,
                    Value: res.Data[i].Aciklama,
                    BaslamaTarihi: res.Data[i].BaslamaTarihi,
                    BitisTarihi: res.Data[i].BitisTarihi
                  });
                }
              }
       //     }
          });
        });
      }
    },
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsFilterGet({ Service: "okeyvalues", Page: this.Page, Filter: "&Tip=1561&Kod=5" }).then((resp) => {
      this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: "&TipId=" + resp.Data[0].Id + "&UstIdDoluMu=false&Approval=true" }).then((res) => {
   //     let Tarih = moment(new Date()).format("YYYY-MM-DD");
        for (var i = 0; i < res.Data.length; i++) {
      //    if (this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= Tarih && Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)) {
            this.ComboBoxDonemId.push({
              Id: res.Data[i].Id,
              Value: res.Data[i].Aciklama,
            });
        //  }
        }
      });
    });
    this.ActionsGet({ Service: "OBirim", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.ComboBoxBirimId.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].BirimAdi,
        });
      }
    });

  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-sm-12">
              <div class="row ">


                
              </div>

              <div class="row ">


                <div class="col-md-6">
                  <formcombobox :FormDataType="{
                    FieldName: 'DonemId',
                    Field: 'combobox',
                    FieldTitle: $t('StrRiskEylemPlani.Filtreleme.UstDonemId'),
                    ComboDataArray: ComboBoxDonemId,
                  }" :Value="Filter.DonemId" :v="$v.Filter.DonemId" @input="(Filter.DonemId = $event), DonemSec()" />
                </div>
                <div class="col-md-6">
                  <formcombobox :FormDataType="{
                    FieldName: 'Risktipi',
                    Field: 'combobox',
                    FieldTitle: $t('StrRiskEylemPlani.Filtreleme.Risktipi'),
                    ComboDataArray: RiskTipiComboBox,
                  }" :Value="Filter.Risktipi" :v="$v.Filter.Risktipi" @input="(Filter.Risktipi = $event)" />
                </div>
                <div class="col-md-6 mb-3">
                  <formcombobox :FormDataType="{
                    FieldName: 'AltDonemId',
                    Field: 'combobox',
                    FieldTitle: $t('StrRiskEylemPlani.Filtreleme.DonemId'),
                    ComboDataArray: ComboBoxAltDonemId,
                  }" :Value="Filter.AltDonemId" :v="$v.Filter.AltDonemId" @input="(Filter.AltDonemId = $event), DonemBaslamaTarihi($event)" />
                </div>
                <div class="col-md-6">
                    <BirimSecimi
                        :title="'Birim'"
                        :title_class="'mb-2'"
                        :closeOnSelect="true"
                        :sutun="'0'"
                        :multiple="false"
                        :YetkiKontrol="1"
                        :BirimTipId="null"
                        @Secilmis_Idler="Secilmis_Idler($event)"
                      />
                </div>

                <div class="row">
                  <div class="col-md-2 " style="padding-right: 0px;">
                    <b-button @click="FilterGet()" class="btn btn-primary w-100" variant="primary">{{
                      $t("StrRiskEylemPlani.Filtreleme.Button") }}</b-button>
                  </div>
          
                </div>

              </div>
              <div class="row">
                <div class="col-12" v-if="Object.keys(TableData).length > 0">
        <div class="card"> 
          <div class="card-body"> 
            <div class="table-responsive" v-for="(Data, index) in TableData" :key="index">
              <table class="table table-striped table-bordered mb-0">
                <thead>
                  <tr>
                    <th scope="col">{{ Data.Risk }}</th>
                  </tr>
                </thead>
                <tbody>

                    <Eylem :KontrolTrue="KontrolGet" @OnayKaldir="BirimEylemOnayKaldir()" @Onay="BirimEylemOnay1()" @AllKontrolGet="AllKontrolGet()" :RiskId="Data.Id" :Risk="Data.Risk" :BirimId = "Filter.BirimId" :AltDonemId="Filter.AltDonemId" @FormData="FormData = $event" :Index = "index" @TableUpdate="FilterGet()" :AltDonemAktif = "AltDonemAktif" />
           
                </tbody>
              </table>
              <br /><br />
            </div>
          </div>
        </div>
      </div>
              </div>


            </div>
  
          </div>

        </div>
      </div>
      <b-modal id="EylemKontrolAciklama" size="m" title="" title-class="font-18"
                      hide-footer>
                      <Form @submit.prevent="onSubmit">
                        <formtextarea :FormDataType="FormDataType.Aciklama" :Value="FormData.Aciklama" :v="$v.FormData.Aciklama"
                          @input="FormData.Aciklama = $event" />
                        <button class="btn btn-primary" type="submit">
                          {{ $t("StrKontrolGiris.AddEdit.Button") }}
                        </button>
                      </Form>
                    </b-modal>
                    <EylemKontrolKanit :RiskGirisCevapId="FormData.Id" />

    </Layout>

  </Loader>
</template>
